// @flow

import { type OutgoingPayment } from './types';

export function getPaymentType(outgoingPayment: OutgoingPayment): string {
  return outgoingPayment['payment_type'];
}
